import { useIcons } from "@/hooks/useIcons";
import React from "react";

/// AUTOGENERATED, DO NOT EDIT, see `scripts/icons.clj`

export function ExclamationCircle(): React.JSX.Element {
  const { ExclamationCircle } = useIcons();
  return <ExclamationCircle />;
}

export function MuxArrowLeft(): React.JSX.Element {
  const { MuxArrowLeft } = useIcons();
  return <MuxArrowLeft />;
}

export function MuxArrowRight3(): React.JSX.Element {
  const { MuxArrowRight3 } = useIcons();
  return <MuxArrowRight3 />;
}

export function MuxAutoFilter(): React.JSX.Element {
  const { MuxAutoFilter } = useIcons();
  return <MuxAutoFilter />;
}

export function MuxChevronDown2(): React.JSX.Element {
  const { MuxChevronDown2 } = useIcons();
  return <MuxChevronDown2 />;
}

export function MuxChevronRight(): React.JSX.Element {
  const { MuxChevronRight } = useIcons();
  return <MuxChevronRight />;
}

export function MuxChevronUp2(): React.JSX.Element {
  const { MuxChevronUp2 } = useIcons();
  return <MuxChevronUp2 />;
}

export function MuxCopy(): React.JSX.Element {
  const { MuxCopy } = useIcons();
  return <MuxCopy />;
}

export function MuxDrag(): React.JSX.Element {
  const { MuxDrag } = useIcons();
  return <MuxDrag />;
}

export function MuxDragHandle2(): React.JSX.Element {
  const { MuxDragHandle2 } = useIcons();
  return <MuxDragHandle2 />;
}

export function MuxExport(): React.JSX.Element {
  const { MuxExport } = useIcons();
  return <MuxExport />;
}

export function MuxFavorite(): React.JSX.Element {
  const { MuxFavorite } = useIcons();
  return <MuxFavorite />;
}

export function MuxGoTo(): React.JSX.Element {
  const { MuxGoTo } = useIcons();
  return <MuxGoTo />;
}

export function MuxInfoCircle(): React.JSX.Element {
  const { MuxInfoCircle } = useIcons();
  return <MuxInfoCircle />;
}

export function MuxInfoRedCircle(): React.JSX.Element {
  const { MuxInfoRedCircle } = useIcons();
  return <MuxInfoRedCircle />;
}

export function MuxPencil(): React.JSX.Element {
  const { MuxPencil } = useIcons();
  return <MuxPencil />;
}

export function MuxPencilRename(): React.JSX.Element {
  const { MuxPencilRename } = useIcons();
  return <MuxPencilRename />;
}

export function MuxPlusCircle(): React.JSX.Element {
  const { MuxPlusCircle } = useIcons();
  return <MuxPlusCircle />;
}

export function MuxRegPlus(): React.JSX.Element {
  const { MuxRegPlus } = useIcons();
  return <MuxRegPlus />;
}

export function MuxSetting(): React.JSX.Element {
  const { MuxSetting } = useIcons();
  return <MuxSetting />;
}

export function MuxTabFilter(): React.JSX.Element {
  const { MuxTabFilter } = useIcons();
  return <MuxTabFilter />;
}

export function MuxTabFolder(): React.JSX.Element {
  const { MuxTabFolder } = useIcons();
  return <MuxTabFolder />;
}

export function MuxToggle(): React.JSX.Element {
  const { MuxToggle } = useIcons();
  return <MuxToggle />;
}

export function MuxToggle2(): React.JSX.Element {
  const { MuxToggle2 } = useIcons();
  return <MuxToggle2 />;
}

export function MuxTrash(): React.JSX.Element {
  const { MuxTrash } = useIcons();
  return <MuxTrash />;
}

export function MuxX(): React.JSX.Element {
  const { MuxX } = useIcons();
  return <MuxX />;
}
